export default "__VITE_ASSET__BwCxA0KP__"